exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir] .alert-message{background-color:#f4f2ed;padding-top:20px;padding-bottom:35px}.alert-message .alert-icon,.alert-message .alert-icon svg{min-height:30px;max-height:30px;min-width:30px;max-width:30px}[dir=ltr] .alert-message .alert-icon,[dir=ltr] .alert-message .alert-icon svg{margin-right:10px}[dir=rtl] .alert-message .alert-icon,[dir=rtl] .alert-message .alert-icon svg{margin-left:10px}@media (min-width:768px){[dir] .alert-message{padding-top:30px;padding-bottom:45px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/alert-message/alert-message.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/alert-message/alert-message.component.scss
// module chunks = 0